import { render } from "./Aduan.vue?vue&type=template&id=761007d0"
import script from "./Aduan.vue?vue&type=script&lang=js"
export * from "./Aduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__